import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Overline } from "@/components/common/Primitives";

export function PageHero({ overline, title, subtitle, image, crumb }) {
  return (
    <section className="relative overflow-hidden bg-automex-navy pt-28 md:pt-32" data-testid="page-hero">
      <div className="absolute inset-0">
        <img src={image} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-black/45" />
      </div>
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 py-20 md:py-28">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <nav className="mb-6 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-200">
            <Link to="/" className="hover:text-automex-teal">Home</Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-automex-teal">{crumb || title}</span>
          </nav>
          <Overline light>{overline}</Overline>
          <h1 className="mt-4 max-w-4xl font-heading text-4xl sm:text-6xl md:text-7xl font-black uppercase tracking-tighter leading-[0.9] text-white">
            {title}
          </h1>
          {subtitle && <p className="mt-6 max-w-2xl text-base sm:text-lg text-white leading-relaxed">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}
